import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';

import LanguageLocaleUtils from 'utils/LanguageLocale';
import FrameworkUtils from 'utils/framework';

import AddressActions from 'actions/AddressActions';

import AddNewAddressModal from 'components/RichProfile/MyAccount/AutoReplenishment/ManageAddress/AddNewAddressModal/AddNewAddressModal';

import AddNewAddressModalEN from 'components/RichProfile/MyAccount/AutoReplenishment/ManageAddress/AddNewAddressModal/locales/AddNewAddressModal_en_US';
import AddNewAddressModalFR from 'components/RichProfile/MyAccount/AutoReplenishment/ManageAddress/AddNewAddressModal/locales/AddNewAddressModal_fr_CA';

const { wrapHOC } = FrameworkUtils;

const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;

const getText = getLocalisedDataFromResource(AddNewAddressModalEN, AddNewAddressModalFR);

const localization = createStructuredSelector({
    modalTitle: getTextFromResource(getText, 'modalTitle'),
    setAsDefault: getTextFromResource(getText, 'setAsDefault'),
    enterAddressManually: getTextFromResource(getText, 'enterAddressManually'),
    cancel: getTextFromResource(getText, 'cancel'),
    confirm: getTextFromResource(getText, 'confirm')
});

const fields = createSelector(localization, locales => ({ localization: locales }));

const functions = {
    validateAddress: AddressActions.validateAddress
};

const withAddNewAddressModalProps = wrapHOC(connect(fields, functions));

export default withAddNewAddressModalProps(AddNewAddressModal);
